//eslint-disable
export default [
  "ABNA",
  "ASNB",
  "BUNQ",
  "FVLB",
  "HAND",
  "INGB",
  "KNAB",
  "REVOLUT",
  "MOYO",
  "RABO",
  "RBRB",
  "SNSB",
  "TRIO",
  "account-banner-figure-desktop",
  "account-banner-figure-mob",
  "account-banner-plus",
  "add",
  "alert",
  "american-express",
  "amex",
  "apple-logo",
  "apple-pay",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "black-edit",
  "big-payment-dollar",
  "red-wurm",
  "red-wurm-large",
  "red-circle-cross",
  "reward",
  "calendar",
  "clock",
  "copy",
  "coin",
  "coin-outline",
  "ch",
  "change-membership",
  "change-personal-details",
  "chat-mobile",
  "chat-desktop",
  "checkmark-icon",
  "cs",
  "custom-arrow-right",
  "custom-arrow-left",
  "cz",
  "black-polygon",
  "braintree-paypal",
  "red-cross",
  "red-cross-small",
  "rounded-circle-with-cross",
  "arrow-up",
  "at",
  "back",
  "bacteria",
  "bancontact",
  "basket-diap",
  "basket",
  "be",
  "book",
  "box-cross",
  "boxer-arrows",
  "braintree-creditcard",
  "boxer-circle",
  "boxer-color-switch",
  "boxer-cross",
  "boxer-multiple",
  "boxer-multiple-blanc",
  "boxer",
  "boxer-blanc",
  "calendar-white",
  "card",
  "card-blanc",
  "cart",
  "chat",
  "chevron-down",
  "checklist",
  "checklist-blanc",
  "checkmark",
  "creditcard",
  "close",
  "cross",
  "da",
  "download",
  "danger",
  "de",
  "decrease",
  "detailed-boxer",
  "detailed-calender",
  "detailed-form",
  "detailed-packaging",
  "detailed-number-one",
  "detailed-women-packaging",
  "dk",
  "dryer-diap",
  "dryer",
  "edit-filled",
  "edit-white",
  "edit",
  "email",
  "email-magnifier",
  "email-in-circle",
  "en",
  "es",
  "eps",
  "exit",
  "extra",
  "eye-closed",
  "eye-open",
  "face",
  "face-blanc",
  "facebook",
  "facebook-messenger",
  "facebook-white",
  "favicon-100",
  "favicon-16",
  "favicon-32",
  "forward",
  "fr",
  "fi",
  "gift",
  "giropay",
  "google",
  "google-calendar",
  "google-pay",
  "ie",
  "ideal",
  "increase",
  "info",
  "info-solid",
  "instagram",
  "instagram-white",
  "iron-diap",
  "iron",
  "skateboard",
  "labelsvg",
  "large-x-logo",
  "light",
  "lu",
  "loyalty-program",
  "it",
  "hamburger",
  "halloween",
  "header-lightning",
  "header-lightning-large",
  "heart-solid",
  "heart-outlined",
  "lightning",
  "lock-magnifier",
  "logo-diap",
  "logo-boys-diap",
  "logo-one",
  "logo",
  "logout",
  "loop-arrow",
  "loyalty-usp-1",
  "loyalty-usp-2",
  "loyalty-usp-3",
  "maestro",
  "magnifier",
  "mail",
  "mastercard",
  "mc",
  "min",
  "measure-white",
  "measure",
  "medium-x-logo",
  "menu-closed",
  "membership-boxershort",
  "membership-socks",
  "membership-women",
  "menu-open",
  "music-notes",
  "nationale-nederlanden",
  "n26",
  "new-arrow-left",
  "new-big-plus-icon",
  "new-chevron-left",
  "new-chevron-down",
  "new-chevron-right",
  "new-danger",
  "new-home-outline",
  "new-home-solid",
  "new-subscription-outline",
  "new-subscription-solid",
  "new-mail",
  "new-settings-outline",
  "new-settings-solid",
  "new-orders-outline",
  "new-orders-solid",
  "new-lock-outline",
  "new-log-out",
  "new-gift-solid",
  "new-gift-outline",
  "new-star-solid",
  "new-star-outline",
  "nl",
  "no",
  "noun-calender",
  "noun-click",
  "noun-coin",
  "noun-membership",
  "noun-pant",
  "noun-view",
  "OTA",
  "ota-world-map",
  "ota-x",
  "orange-hagelslang",
  "orange-planet",
  "orderbundle-banner",
  "outlook-calendar",
  "payment-cross",
  "pause-icon",
  "pause-calender",
  "pepper",
  "payment-dollar",
  "payment-magnifier",
  "paypal",
  "pinpoint-white",
  "person",
  "pinpoint",
  "pl",
  "plus",
  "pt",
  "price-tag",
  "purple-hagelslag",
  "purple-heart",
  "purple-triangle",
  "purple-planet",
  "purple-smiley",
  "purple-gameboy",
  "rating",
  "refer-a-friend",
  "reasonOne",
  "reasonTwo",
  "reasonTwoMixed",
  "reasonThree",
  "sock",
  "sound-off",
  "se",
  "secure-payment-lock",
  "sepa",
  "send-message",
  "star",
  "stair-tree",
  "star-empty",
  "star-half",
  "thumb-down",
  "thumb-up",
  "thumb-up-icon",
  "thumbs-up",
  "thin-cross",
  "timer",
  "triangle-cross-diap",
  "triangle-cross",
  "twitter",
  "boxer-diap",
  "sock-diap",
  "time-time",
  "truck-checkmark",
  "truck-dollar",
  "truck",
  "truck-blanc",
  "gb",
  "question-bubble",
  "update-payment",
  "undershirt",
  "user",
  "whatsapp",
  "women-how-it-works-1",
  "women-how-it-works-2",
  "women-how-it-works-3",
  "women-how-it-works-4",
  "women-underwear",
  "visa",
  "yellow-spiral",
  "yellow-spiral-2",
  "youtube",
  "yoursafe"
]
